// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__fammi","defaultSpan":"Toggle_defaultSpan__bgZO1","bold":"Toggle_bold__Gkzz4"};